import {BulbOutlined, EnvironmentOutlined, FileAddOutlined, UserOutlined} from '@ant-design/icons'
import {Button, Col, DatePicker, Divider, Form, Input, message, Row, Select, Space, Spin, Steps, Typography} from 'antd'
import moment from 'moment'
import React from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {getArtistExhibition, patchArtistExhibition, postArtistExhibition} from '../../api/artistExhibition'
import '../../asset/less/component.css'
import ApplyFormErrorMessage from '../../component/apply/ApplyFormErrorMessage'
import HttpError from '../../component/base/HttpError'
import AddExhibitionArtwork from '../../component/exhibition/AddExhibitionArtwork'
import {getPageId} from '../../component/Utils'
import {URL_EXHIBITIONS} from '../../const'
import {is_admin_user} from "../../app/role";
import {RequiredTitle} from "../../component/piece/common";
import PublicSettingsExhibition from "../../component/exhibition/PublicSettingsExhibition";

const {Title, Text} = Typography
const {Step} = Steps
const {TextArea} = Input

@connect((state) => ({
    siderWidth: state.style.siderWidth,
    role: state.user.info.role,
    artistId: state.user.info.artistId,
    artists: state.artist.artistNames
}))

class AddNewExhibition extends React.Component {

    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = {
            exhibition: {},
            exhibitionId: 0,
            currentStep: 0,
            validateError: [],
            targetKeys: null,
            pageSize: 10,
            showImage: true,
            loading: false,
            actionLoading: false,
            artists: null,
            has_artwork_exhibition: false,
            gallery_name: null
        }
    }

    componentDidMount() {
        // New exhibition
        if (this.props.new === true) {
            if (is_admin_user(this.props) && this.props.artistId) {
                this.formRef.current.setFieldsValue({
                    'artist': this.props.artistId,
                })
                this.setState({
                    artists: [this.props.artistId]
                })
            }
            return
        }
        // Edit exhibition
        let id = this.getExhibitionId()
        getArtistExhibition(id).then((response) => {
            this.changeDateStringToDatePicker(response.data, 'YYYY-MM-DD')
            let data = response.data
            if (response.data.has_artwork_exhibition) {
                this.setState({
                    has_artwork_exhibition: response.data.has_artwork_exhibition,
                    gallery_name: response.data.gallery_name
                })
            }

            if (!response.data.artist) {
                if (response.data.artist_ids) {
                    data['artist'] = response.data.artist_ids.split(",")
                    this.setState({
                        artists: data['artist']
                    })
                }
            } else {
                data['artist'] = data.artist.toString()
                this.setState({
                    artists: [data['artist']]
                })
            }
            this.formRef.current.setFieldsValue(data)

            this.setState({
                exhibitionId: response.data.id,
                exhibition: response.data
            })
        }).catch((error) => {
            HttpError(error)
        })
    }

    getExhibitionId = () => {
        return getPageId(this.props)
    }

    saveAndContinue = () => {
        if (this.state.currentStep === 0) {
            this.formRef?.current.submit()
        } else if (this.state.currentStep === 1) {
            this.onAddArtworkSave()
        } else {
            this.onPublishSave()
        }
    }

    changeDatePickerToString = (params, format) => {
        Object.keys(params).forEach((key) => {
            if (params[key] && params[key]._isAMomentObject) {
                params[key] = params[key].format(format)
            }
        })
    }

    changeDateStringToDatePicker = (params, format) => {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        Object.keys(params).forEach((key) => {
            if (params[key] && params[key].toString().match(regEx)) {
                params[key] = moment(params[key], format)
            }
        })
    }

    onFinish = (values) => {
        if (this.props.new === true) { // For NEW
            const params = {
                ...values
            }
            if (this.state.artists) {
                params['artist'] = this.state.artists.join(",")
            }
            if (!params['artist'] && this.props.artistId) {
                params['artist'] = this.props.artistId;
                this.setState({
                    artists: [this.props.artistId]
                })
            }
            this.changeDatePickerToString(params, 'YYYY-MM-DD')
            this.createArtistExhibition(params)
        } else { // For EDIT
            const params = values
            this.changeDatePickerToString(params, 'YYYY-MM-DD')
            this.updateArtistExhibition(params)
        }
    }

    onFinishFailed = ({values, errorFields, outOfDate}) => {
        this.setState({validateError: errorFields})
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    moveToAddArtworkPage = (exhibitionId) => {
        this.setState({
            exhibitionId: exhibitionId,
            loading: false,
            currentStep: this.state.currentStep + 1,
            targetKeys: this.state.exhibition.artwork_ids ? this.state.exhibition.artwork_ids.split(',').map(Number) : []
        })
    }

    moveToPublicPage = (exhibitionId) => {
        this.setState({
            exhibitionId: exhibitionId,
            loading: false,
            currentStep: this.state.currentStep + 1,
            targetKeys: []
        })
    }

    onAddArtworkSave = () => {
        if (this.state.targetKeys.length === 0) {
            this.setState({
                validateError: [
                    {
                        name: 'image',
                        errors: ["Selected pieces can't be blank"]
                    }
                ]
            })
            return
        }
        const params = {
            artwork_ids: this.state.targetKeys.join(',')
        }
        this.updateArtistExhibition(params)
    }

    onPublishSave = () => {
        const params = {
            'has_artwork_exhibition': this.state.has_artwork_exhibition,
        }
        this.updateArtistExhibition(params)
    }

    createArtistExhibition(params) {
        this.setState({actionLoading: true})
        postArtistExhibition(params)
            .then((response) => {
                this.moveToAddArtworkPage(response.data.id)
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({actionLoading: false})
        })
    }

    onSelectPublicChange = () => {
        this.setState({
            'has_artwork_exhibition': !this.state.has_artwork_exhibition
        })
    }

    updateArtistExhibition(params) {
        this.setState({actionLoading: true})
        delete params['artist']
        patchArtistExhibition(this.state.exhibitionId, params)
            .then((response) => {
                message.success('Saved successfully').then(() => {
                })
                if (this.state.currentStep === 0) { // if on first page
                    this.moveToAddArtworkPage(this.state.exhibitionId)
                } else if (this.state.currentStep === 1) { // If on second page
                    this.moveToPublicPage(this.state.exhibitionId)
                } else {
                    this.props.history.push({pathname: URL_EXHIBITIONS})
                }
            })
            .catch((error) => {
                HttpError(error)
            }).finally(() => {
            this.setState({actionLoading: false})
        })
    }

    exhibitionInfoView = () => {
        return (
            <Form layout='vertical' ref={this.formRef}
                  onFinish={this.onFinish} style={{padding: 24}}>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        {is_admin_user(this.props) && !this.props.artistId && (
                            <>
                                <Form.Item name='artist' style={{width: '100%'}} label={RequiredTitle('Artists')}
                                           rules={[{required: true}]}>
                                    <Select
                                        style={{maxWidth: '100%'}}
                                        showSearch
                                        optionFilterProp='label'
                                        mode="multiple"
                                        placeholder='Please select artists'
                                        onChange={(e) => {
                                            this.setState({artists: e})
                                        }}
                                        options={this.props.artists?.map((artist) => ({
                                            value: artist.artist_id,
                                            label: artist.name
                                        }))}
                                        disabled={!this.props.new}
                                    />
                                </Form.Item>
                            </>
                        )}
                        {is_admin_user(this.props) && this.props.artistId && (
                            <>
                                <Form.Item name='artist' style={{width: '100%'}} label={RequiredTitle('Artists')}
                                           rules={[{required: false}]}>
                                    <Select
                                        style={{maxWidth: '100%'}}
                                        showSearch
                                        optionFilterProp='label'
                                        mode="multiple"
                                        placeholder='Please select artists'
                                        options={this.props.artists?.map((artist) => ({
                                            value: artist.artist_id,
                                            label: artist.name
                                        }))}
                                        disabled={true}
                                    />
                                </Form.Item>
                            </>
                        )}
                        <Form.Item name='name' label='Exhibition Name' style={{flexGrow: 4}} rules={[
                            {
                                required: true,
                                message: 'Please input the name of the exhibition'
                            }
                        ]}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name='type' label='Type' style={{flexGrow: 2}}>
                            <Select
                                prefix={<BulbOutlined/>}
                                placeholder='Select exhibition type'
                                options={[
                                    {value: 'solo-show', label: 'Solo Show'},
                                    {value: 'group-show', label: 'Group Show'},
                                    {value: 'exhibition', label: 'Exhibition'},
                                    {value: 'art-fair', label: 'Art Fair'},
                                    {value: 'art-project', label: 'Art Project'},
                                    {value: 'art-festival', label: 'Art Festival'},
                                ]}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Divider/>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='location' label='Location' style={{flexGrow: 4}}>
                            <Input prefix={<EnvironmentOutlined/>}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='street' label='Street' style={{flexGrow: 4}}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name='state' label='State (U.S Only)' style={{flexGrow: 2}}>
                            <Input/>
                        </Form.Item>
                        <Form.Item name='zipcode' label='Zipcode' style={{flexGrow: 2}}>
                            <Input/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider/>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='start_date' label='Start Date' style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='end_date' label='End Date' style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='open_reception_date' label='Opening Reception Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='delivery_date' label='Delivery Date' style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='installation_begin_date' label='Installation Begin Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='installation_end_date' label='Installation End Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='de_installation_begin_date' label='Deinstallation Begin Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='de_installation_end_date' label='Deinstallation End Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                        <Form.Item name='pick_up_art_date' label='Pick Up Art Date'
                                   style={{width: '30%', minWidth: 260}}>
                            <DatePicker format='YYYY-MM-DD'/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider/>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='curator' label='Curator' style={{width: '30%', minWidth: 260}}>
                            <Input prefix={<UserOutlined/>}/>
                        </Form.Item>
                        <Form.Item name='website' label='Website' style={{width: '60%', minWidth: 260}} rules={[
                            {
                                maxLength: 100,
                                message: 'maximum length is 100'
                            }
                        ]}>
                            <Input addonBefore="http://"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}
                         style={{display: 'flex', alignItems: 'flex-start', width: '100%', flexWrap: 'wrap', gap: 24}}>
                        <Form.Item name='exhibition_description' label='Exhibition Description' style={{width: '100%'}}>
                            <Input.TextArea showCount maxLength={20480}
                                            autoSize={{minRows: 12, maxRows: 12}}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        )
    }

    addArtworkView = () => {
        return (
            <AddExhibitionArtwork initTargetKeys={this.state.targetKeys} artistIds={this.state.artists}
                                  role={this.props.role} onTargetKeysChange={(keys) => {
                this.setState({targetKeys: keys})
            }}/>
        )
    }

    addPublishView = () => {
        return (
            <PublicSettingsExhibition is_publish={this.state.has_artwork_exhibition}
                                      gallery_name={this.state.gallery_name}
                                      onSelectPublicChange={this.onSelectPublicChange}/>
        )
    }

    render() {
        const steps = [
            {title: 'Exhibition', view: this.exhibitionInfoView(), buttons: ['Cancel', 'Save & Continue']},
            {title: 'Add Artwork', view: this.addArtworkView(), buttons: ['Finish Later', 'Save & Continue']},
            {title: 'Publish', view: this.addPublishView(), buttons: ['Finish Later', 'Save']}
        ]
        return (
            <Spin size='large' spinning={this.state.loading}>

                <Row align='bottom' gutter={{xs: 8, sm: 16, md: 24}}>
                    <Col>
                        <Title level={2} style={{marginBottom: 0}}>
                            <FileAddOutlined/> <Space/>
                            {(this.props.new === true ? "Add Exhibition" : "Edit Exhibition")}
                        </Title>
                    </Col>
                </Row>
                <ApplyFormErrorMessage error={this.state.validateError}/>

                <Row style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: 1200,
                    paddingLeft: '3vw',
                    paddingRight: '3vw',
                    marginTop: '3vw'
                }}>
                    <Steps labelPlacement='vertical' current={this.state.currentStep}
                           style={{marginLeft: 'auto', marginRight: 'auto', width: 640}}>
                        {
                            steps.map((item, index) => (<Step key={item.title} title={item.title}/>))
                        }
                    </Steps>
                </Row>

                <div style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    maxWidth: 1200,
                    minHeight: 340
                }}>{steps[this.state.currentStep].view}</div>


                <Row justify='start'
                     style={{
                         padding: 16,
                         bottom: 0,
                         position: 'fixed',
                         zIndex: 1,
                         right: 16,
                         left: 16 + this.props.siderWidth,
                         backgroundColor: 'rgba(255,255,255,0.4)'
                     }}
                >
                    <Button style={{marginRight: 'auto', marginLeft: '12%'}} type="dashed" onClick={(e) => {
                        this.props.history.push({pathname: URL_EXHIBITIONS})
                    }}
                            size='middle'
                            htmlType='submit'> {steps[this.state.currentStep].buttons[0]} </Button>
                    <Button style={{marginLeft: 'auto', marginRight: '12%'}} type="primary"
                            loading={this.state.actionLoading} onClick={(e) => {
                        this.saveAndContinue()
                    }} size='middle' htmlType='submit'>
                        {steps[this.state.currentStep].buttons[1]}
                    </Button>
                </Row>
            </Spin>
        )
    }
}

export default withRouter(AddNewExhibition)
